import React, { createContext, useState } from "react";
import { Locale } from "./locales";

type LocaleContextType = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};

const LocaleContext = createContext<LocaleContextType>({
  locale: Locale.zhCN,
  setLocale: () => {},
});

const LocaleProvider: React.FC<any> = ({ children }) => {
  const [locale, setLocale] = useState<Locale>(Locale.zhCN);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};

export default LocaleProvider;
export { LocaleProvider, LocaleContext };
